import React from 'react'
import './StudioPoliciesPage.css'
import Header from '../components/Header'
import Footer from '../components/Footer'

function StudioPoliciesPage() {
  return (
    <div className="page_container" id="studio-policies-page">
      <section className="page_section" id="hero-section">
        <Header />
        <div className="sub_section title_section">
          <h1>Studio Policies</h1>
        </div>
      </section>

      <section className="page_section" id="policies-content">
        <div className="content_box">
          <div className="policy-section">
            <h2>Timeliness</h2>
            <p>
              Please arrive on time and make dance a regular part of your schedule. Missing the warm-up increases the risk of injuries.
            </p>
          </div>

          <div className="policy-section">
            <h2>Jewelry</h2>
            <p>
              Kindly remove all jewelry or accessories (including rings, bracelets and watches) before entering the class. This to improve your grip and safety, protect the poles from scratches, and prevent your material from damage.
            </p>
          </div>

          <div className="policy-section">
            <h2>Food and drinks</h2>
            <p>
              No food or drinks are allowed in the pole room, except for a (reusable) closed bottle. Chewing gum is strictly forbidden due to choking hazard. Coffee, water and soft drinks can be purchased in the venue or on the mezzanine.
            </p>
          </div>

          <div className="policy-section">
            <h2>Cleanliness</h2>
            <p>
              Put your waste in the dust bin. Clean the poles after the class and put them back on static mode. Do not leave any of your stuff in the middle of the room so that nobody - yourself included - struggles over it. Clean your mats, fold the rubber bands and put them back in their places after use. Used towels go in the towel bin. When leaving the room, reassure yourself that you have taken all your belongings with you.
            </p>
          </div>

          <div className="policy-section">
            <h2>Duration</h2>
            <p>
              It is important to stay for the entire class. If you need an exception, please ask the teacher.
            </p>
          </div>

          <div className="policy-section">
            <h2>Attentiveness and listening</h2>
            <p>
              Pay close attention to all instructions, including spotting techniques. Please remain silent when the teacher is giving instructions or explanations and avoid engaging in side conversations while the instructor is teaching.
            </p>
          </div>

          <div className="policy-section">
            <h2>Smartphones and filming</h2>
            <p>
              Smartphones can only be used for filming during the class. Please refrain from using your phone for any other purposes such as texting, reading, or calling. We encourage you to share your performances with family and friends, but prioritize your safety and the safety of others while filming. Respect the privacy of fellow students and teachers by asking for permission before including them in your videos. Filming during instructional moments is not permitted unless approved. Remember, these videos are for private use only and should not be posted.
            </p>
          </div>

          <div className="policy-section">
            <h2>Hygiene</h2>
            <p>
              Please maintain good personal hygiene during your time in the studio.
            </p>
          </div>

          <div className="policy-section">
            <h2>Respect</h2>
            <p>
              Show respect to your instructors, fellow students, and yourself.
            </p>
          </div>

          <div className="policy-section">
            <h2>Spirit</h2>
            <p>
              Give your best effort and understand that learning pole dancing takes time. Hard work pays off, and you will progress over time. Enjoy the journey and have fun 😊
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default StudioPoliciesPage 